<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <v-flex xs12>
            <span class="heading">Users List</span>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-start pt-2>
              <!-- <v-flex xs12 sm6 md6 lg6 class="subheading">
                <span>Rows per page</span>
                <v-select
                  v-model="limit"
                  color="#FF6907"
                  outlined
                  dense
                  hide-details
                  :items="[20, 30, 50]"
                ></v-select>
              </v-flex> -->
              <v-flex xs12 sm3 md3 lg3>
                <span class="subheading">Filter</span>
                <v-text-field
                  outlined
                  hide-details
                  dense
                  placeholder="Type To Search"
                  v-model="keyword"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 v-if="snakeType && snakeType.length > 0">
                <!-- <v-layout wrap justify-start>
                  <v-flex xs12 pt-4>
                    <v-layout wrap>
                      <v-flex
                        xs12
                        lg4
                        sm6
                        md6
                        v-for="(item, index) in snakeType"
                        :key="index"
                        pa-2
                      >
                        <v-card class="mb-4">
                          <v-card-title>
                            <span class="heading">{{ item.name }}</span>
                          </v-card-title>
                          <v-card-subtitle>
                            <span class="subheading">
                              <span v-if="item.is_rescuer">Rescuer</span>
                              <span v-else>User</span> </span
                            ><br />
                            <span class="subheading">{{ item.email }}</span
                            ><br />
                            <span class="subheading">{{ item.phone }}</span>
                          </v-card-subtitle>
                          <v-card-actions>
                            <span><v-icon small color="green" class="ml-5" @click="openEditDialog(item)">mdi-pencil</v-icon></span>
                            <span><v-icon small color="red" class="ml-5"  @click="openDeleteDialog(item)">mdi-delete</v-icon></span>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout> -->
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <v-card>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-start tableheading">Name</th>
                              <th class="text-center tableheading">Action</th>
                              <!-- <th class="text-center tableheading">Delete</th> -->
                            </tr>
                          </thead>
                          <tbody class="tablesubheading">
                            <tr v-for="(item, index) in snakeType" :key="index" class="text-center">
                              <td class="text-start" @click="goToAIImages(item._id)" style="cursor: pointer;">
                                <span v-if="item && item.name">{{
                                  item.name
                                }}</span>
                                <span v-else>-</span>
                              </td>
                              <td>
                                <span
                                  ><v-icon
                                    color="blue"
                                    small
                                    @click="goToAIImages(item._id)"
                                    >mdi-eye</v-icon
                                  ></span
                                >
                                <!-- <span
                                  ><v-icon
                                    color="red"
                                    small
                                    class="ml-5"
                                    @click="openDeleteDialog(item)"
                                    >mdi-delete</v-icon
                                  ></span
                                > -->
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pb-4 v-if="snakeType && snakeType.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              :total-visible="7"
              circle
              color="#FF6907"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else>
        <v-layout wrap justify-center pl-5>
          <v-flex xs12 class="text-center">
            <span class="heading">No Data Found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
  </div>
</template>
  <script>
import axios from "axios";
import debounce from 'lodash/debounce';
export default {
  data() {
    const pageKey = this.$route.name || 'defaultPage';
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      limit: 20,
      keyword: "",
      pageKey,
      currentPage: parseInt(localStorage.getItem(`${pageKey}_currentPage`)) || 1,
      Pagelength: 0,
      snakeType: [],
      confirmDeleteDialog: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage(newVal) {
      localStorage.setItem(`${this.pageKey}_currentPage`, newVal);
      this.getData();
    },
    limit() {
      this.getData();
    },
    // keyword() {
    //   this.getData();
    // },
    keyword: {
      handler: debounce(function () {
        this.currentPage = 1;
        this.getData();
      }, 500),
      immediate: false,
    },
  },
  methods: {
    openDeleteDialog(item) {
      this.deleteUserItem = item;
      this.confirmDeleteDialog = true;
    },
    goToAIImages(id) {
    this.$router.push({ name: 'aiImages', params: { id } });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/snake/list-names",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          limit: this.limit,
          page: this.currentPage,
          name: this.keyword,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.snakeType = response.data.data;
              this.Pagelength = response.data.totalPages;
              // this.msg = response.data.msg;
              // this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    handlesubmit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/snake/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.commonname,
          scientificName: this.scientificname,
          states: this.state,
          rname: this.reginonalname,
          distribution: this.distribution,
          characteristics: this.scalation,
          description: this.description,
          venomType: this.venomtype,
          family: this.family,
          occurence: this.occurence,
          wlpa: this.wlpa,
          iucn: this.iucn,
          shortdes: this.shortdescription,
          othernames: this.othername,
          genus: this.genus,
          experts: this.experts,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
              this.commonname = "";
              this.scientificname = "";
              this.state = "";
              this.reginonalname = "";
              this.distribution = "";
              this.scalation = "";
              this.description = "";
              this.venomtype = "";
              this.family = "";
              this.occurence = "";
              this.wlpa = "";
              this.iucn = "";
              this.shortdescription = "";
              this.othername = "";
              this.genus = "";
              this.experts = "";
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
  },
};
</script>
  <style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
.tableheading {
  font-family: poppinsregular;
  font-size: 15px !important;
  color: black !important;
  text-transform: uppercase !important;
}
.tablesubheading {
  font-family: poppinsregular;
  font-size: 10px;
}
</style>